import { createGlobalStyle } from 'styled-components';

import ArboriaBook from '@/fonts/Arboria-Book.ttf';
import ArboriaBold from '@/fonts/Arboria-Bold.ttf';
import ArboriaLight from '@/fonts/Arboria-Light.ttf';

const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: 'Arboria Book';
    src: url(${ArboriaBook}) format('truetype');
  }

  @font-face {
    font-family: 'Arboria Bold';
    src: url(${ArboriaBold}) format('truetype');
  }

  @font-face {
    font-family: 'Arboria Light';
    src: url(${ArboriaLight}) format('truetype');
  }

  * {
    box-sizing: border-box;
    margin: 0;
    outline: 0;
    padding: 0;
  }

  #root {
    white-space: pre-line;
  }

  html, body, #root {
    height: 100%;
    min-height: 100%;
  }

  [disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }

  button {
    cursor: pointer;
  }

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  *::-webkit-scrollbar {
    width: 8px;
  }

  *::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.light};
    border: 1px solid ${({ theme }) => theme.colors.divider};
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.divider};
    border: 1px solid ${({ theme }) => theme.colors.divider};
    border-radius: 8px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    html {
      font-size: 84%;
     }
   }

   @keyframes opacityZeroToOne {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
  }
`;

export default GlobalStyle;
